import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"

export const UpdateTimeExpenseEntryMutation = <T>(
  resourceid:string,
  timeExpenseEntry: any,
  callbacks?: Callbacks<T>
) => {
  const { onSuccess, onError, onLoading } = useCallBack<any>(callbacks);
  const urlEncoded = encodeURIComponent(resourceid)
  const { patchRequest } = useHttpRequest({});
  return async (dispatch: any) => {
    const updateTimeExpenseEntry = async () => {
      try {
        const response = await patchRequest(
          `${UrlConstant.TimeExpenseEntry}/${UrlConstant.UpdateByResourceId}?resourceId=${urlEncoded}`,
          timeExpenseEntry
        );
        const data = await response;
        return data;
      } catch (error) {
        onError(error as Error);
      }
    };
    try {
      const res = await updateTimeExpenseEntry();

      if (res) {
        if (res.succeeded) {
          onSuccess(res.message);
          
        } else onError({ message: res.message, name: "" });
      }
    } catch (error) {
      onError(error as Error);
    } finally {
      onLoading(false);
    }
  };
};
